import { addChartDataStyle } from './addChartDataStyle.js';
/**
 * Retrieve a chart with selected original data
 * @param spectra - Array of spectrum objects
 * @param options - Chart options
 * @returns Chart object with data
 */
export function getChart(spectra, options = {}) {
    const { ids, yFactor, xFilter = {} } = options;
    const chart = {
        data: [],
    };
    for (const spectrum of spectra) {
        if (!ids || ids.includes(spectrum.id)) {
            const data = spectrum.getData({ yFactor, xFilter });
            addChartDataStyle(data, spectrum);
            chart.data.push(data);
        }
    }
    return chart;
}
//# sourceMappingURL=getChart.js.map